import React from 'react'

const Cards = () => {
    return (
        <div className='content cards'>
            <div className="cards-container">
                <h3>No card(s) has been linked to this account yet.</h3>
            </div>
        </div>
    )
}

export default Cards
